import { render } from "./GoogleTagManager.vue.ts?vue&type=template&id=845fa5ca&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./GoogleTagManager.vue?vue&type=template&id=845fa5ca&ts=true"
import script from "./GoogleTagManager.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./GoogleTagManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoogleTagManager.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./GoogleTagManager.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/shared-components/common/GoogleTagManager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "845fa5ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('845fa5ca', __exports__)) {
    api.reload('845fa5ca', __exports__)
  }
  
  module.hot.accept("./GoogleTagManager.vue.ts?vue&type=template&id=845fa5ca&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./GoogleTagManager.vue?vue&type=template&id=845fa5ca&ts=true", () => {
    api.rerender('845fa5ca', render)
  })

}


export default __exports__